const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_0eceff3b-f1bb-4f36-8b97-322c9113822b/artifacts/vt53kxt9_ChatGPT%20Image%20Sep%2010%2C%202026%2C%2009_23_10%20AM.png";

export const SITE_CONFIG = {
  name: "On The Counter",
  tagline: "Different Views. Same Passion.",
  logo: LOGO_URL,
};

export const CATEGORIES = [
  { id: "football", name: "Football", color: "#1B7A3D" },
  { id: "boxing", name: "Boxing", color: "#C41E3A" },
  { id: "f1", name: "Formula 1", color: "#E10600" },
  { id: "nba", name: "NBA", color: "#1D428A" },
  { id: "tennis", name: "Tennis", color: "#4E9A06" },
  { id: "rugby", name: "Rugby", color: "#5B2C6F" },
  { id: "cricket", name: "Cricket", color: "#D4A017" },
  { id: "golf", name: "Golf", color: "#2E7D32" },
  { id: "mma", name: "MMA", color: "#B71C1C" },
  { id: "athletics", name: "Athletics", color: "#0277BD" },
];

export const AUTHORS = [
  { id: 1, name: "James Wilson", role: "Football Correspondent", avatar: "https://i.pravatar.cc/150?img=11" },
  { id: 2, name: "Sarah Mitchell", role: "Boxing & MMA Editor", avatar: "https://i.pravatar.cc/150?img=5" },
  { id: 3, name: "Alex Reid", role: "Motorsport Writer", avatar: "https://i.pravatar.cc/150?img=12" },
  { id: 4, name: "Chris Taylor", role: "NBA Analyst", avatar: "https://i.pravatar.cc/150?img=8" },
  { id: 5, name: "Emma Clarke", role: "Tennis & Golf Writer", avatar: "https://i.pravatar.cc/150?img=9" },
  { id: 6, name: "David O'Brien", role: "Rugby Correspondent", avatar: "https://i.pravatar.cc/150?img=15" },
  { id: 7, name: "Priya Sharma", role: "Cricket Writer", avatar: "https://i.pravatar.cc/150?img=25" },
  { id: 8, name: "Marcus Johnson", role: "Athletics Editor", avatar: "https://i.pravatar.cc/150?img=53" },
];

export const ARTICLES = [
  {
    id: 1,
    title: "Why Arsenal's Title Challenge Is the Most Genuine Threat to City in Years",
    excerpt: "Mikel Arteta has built something special at the Emirates. With a blend of experience and youthful exuberance, Arsenal's squad depth finally matches their ambition. Here's why this season feels different.",
    content: `<p>There's something unmistakably different about Arsenal this season. Not just in the results — though those have been remarkable — but in the mentality, the swagger, the unshakeable belief that permeates every corner of the Emirates Stadium.</p>

<p>Mikel Arteta's side have evolved from hopeful challengers into genuine title contenders, and the transformation has been nothing short of extraordinary. Where once there was fragility, there is now steel. Where there was inconsistency, there is now relentless precision.</p>

<h3>The Squad Depth Factor</h3>

<p>What separates this Arsenal team from previous iterations is the quality running through every position. Arteta hasn't just built a strong starting eleven — he's constructed a squad where the difference between first choice and backup is negligible. That depth was exposed last season when injuries derailed their campaign. This time, they've learned.</p>

<p>The midfield trio has been particularly impressive. With Declan Rice orchestrating from deep, Martin Ødegaard pulling strings in the final third, and Kai Havertz providing the kind of versatility that makes tactical adjustments seamless, Arsenal's engine room is the most complete in the Premier League.</p>

<h3>Arteta's Tactical Evolution</h3>

<p>Perhaps most impressive is how Arteta has refined his tactical approach. The rigid structure that sometimes made Arsenal predictable has given way to a more fluid, adaptable system. They can press high or sit deep. They can dominate possession or strike on the counter. This tactical flexibility is what champions need.</p>

<p>The set-piece dominance remains a weapon, but it's no longer the only avenue for goals. Open-play creativity has flourished, with the wide players given more freedom to interchange and exploit spaces.</p>

<h3>The Mental Shift</h3>

<p>But beyond tactics and personnel, it's the psychological transformation that truly sets this campaign apart. Arsenal no longer buckle under pressure. The late winners, the composed performances in hostile environments, the ability to grind out results when not at their best — these are the hallmarks of champions.</p>

<p>Manchester City remain formidable, of course. But for the first time in years, their dominance feels genuinely threatened. Arsenal aren't just hoping to win the title — they expect to.</p>`,
    category: "football",
    author: AUTHORS[0],
    date: "2025-07-10",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?w=1200&h=600&fit=crop",
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: "Fury vs. Usyk Rematch: Can the Gypsy King Reclaim His Throne?",
    excerpt: "After a controversial first bout, Tyson Fury faces Oleksandr Usyk in what could define both fighters' legacies. We break down the tactical battle ahead.",
    content: `<p>The heavyweight division hasn't seen a rivalry this compelling since Lewis vs Holyfield. When Tyson Fury and Oleksandr Usyk step into the ring for their rematch, it won't just be belts on the line — it'll be legacies.</p>

<p>The first fight was a masterclass in contrasting styles. Usyk's technical brilliance against Fury's imposing physicality created a chess match that had the boxing world divided. The decision went Usyk's way, but the margins were razor-thin.</p>

<h3>What Fury Must Change</h3>

<p>For Fury to reverse the result, he needs to fundamentally alter his approach. The jab that once was his most reliable weapon was neutralized by Usyk's head movement and footwork. Fury needs to cut the ring off more effectively and use his size advantage without becoming stationary.</p>

<p>The weight question looms large too. Fury has historically performed best at around 260lbs, but there's been talk of coming in lighter to improve his mobility. It's a gamble — less power but more speed against a fighter who thrives on creating angles.</p>

<h3>Usyk's Blueprint</h3>

<p>Usyk showed in the first fight that he has the recipe for success against Fury. His ability to switch between southpaw and orthodox kept Fury guessing, and his combination punching was devastating in the middle rounds.</p>

<p>The Ukrainian's conditioning is another significant advantage. While Fury tends to fade in the championship rounds, Usyk seems to get stronger. If this fight goes deep, that endurance gap could be the deciding factor once again.</p>`,
    category: "boxing",
    author: AUTHORS[1],
    date: "2025-07-09",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1509563268479-0f004cf3f58b?w=1200&h=600&fit=crop",
    featured: false,
    trending: true,
  },
  {
    id: 3,
    title: "Verstappen's Dominance: Is F1 Heading for Another One-Team Season?",
    excerpt: "Red Bull and Max Verstappen continue to set the pace. But with regulation changes looming, is the competition closer than the standings suggest?",
    content: `<p>Another race weekend, another masterclass from Max Verstappen. The Dutchman's dominance has become so routine that even the most ardent F1 fans are beginning to wonder if the sport has a competitiveness problem.</p>

<p>But look beneath the surface, and the picture is more nuanced than the championship standings suggest.</p>

<h3>The Gap Is Closing</h3>

<p>While Verstappen continues to win, the margins are shrinking. McLaren's resurgence has been the story of the season, with Lando Norris consistently challenging for podiums and occasionally threatening victory.</p>`,
    category: "f1",
    author: AUTHORS[2],
    date: "2025-07-08",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1728116693268-125c5d6ad9e2?w=1200&h=600&fit=crop",
    featured: false,
    trending: true,
  },
  {
    id: 4,
    title: "The NBA's New Super Team Era: Why Player Movement Is Reshaping the League",
    excerpt: "From blockbuster trades to surprise free agency moves, the NBA landscape is shifting faster than ever. We examine how the latest power plays will define the coming season.",
    content: `<p>The NBA has always been a league driven by star power, but the current era of player movement has taken team-building to unprecedented extremes.</p>

<p>This offseason's seismic trades have redrawn the competitive map entirely, creating new contenders overnight while leaving former powerhouses scrambling to rebuild.</p>`,
    category: "nba",
    author: AUTHORS[3],
    date: "2025-07-08",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1608245449230-4ac19066d2d0?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 5,
    title: "Sinner's Reign: How the Italian Is Redefining Modern Tennis",
    excerpt: "Jannik Sinner has established himself as the dominant force in men's tennis. His relentless baseline game and mental fortitude are setting new standards.",
    content: `<p>The tennis world has a new king, and his name is Jannik Sinner. The Italian's ascent to the top of the sport has been both rapid and ruthless.</p>`,
    category: "tennis",
    author: AUTHORS[4],
    date: "2025-07-07",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1545151414-8a948e1ea54f?w=1200&h=600&fit=crop",
    featured: false,
    trending: true,
  },
  {
    id: 6,
    title: "Six Nations Review: The Tactical Trends That Defined the Championship",
    excerpt: "From Ireland's relentless press to France's flair, the Six Nations delivered drama and innovation in equal measure. Our tactical deep dive.",
    content: `<p>The Six Nations never fails to deliver, and this year's championship was no exception. From the opening weekend's shocks to the final day's title decider, every match told a story.</p>`,
    category: "rugby",
    author: AUTHORS[5],
    date: "2025-07-06",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1512299286776-c18be8ed6a1a?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 7,
    title: "The Ashes Preview: England's Path to Redemption Down Under",
    excerpt: "With the Ashes series approaching, England must overcome their troubled history in Australia. Can Stokes' side finally crack the code?",
    content: `<p>The Ashes represents cricket's greatest rivalry, and for England, winning in Australia remains the sport's ultimate challenge.</p>`,
    category: "cricket",
    author: AUTHORS[6],
    date: "2025-07-05",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1512719994953-eabf50895df7?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 8,
    title: "Scheffler's Major Season: The Golfer Who Can't Stop Winning",
    excerpt: "Scottie Scheffler is having a season for the ages. With two majors already secured, can he complete an unprecedented grand slam?",
    content: `<p>In the modern era of golf, dominance is rare. The depth of talent on the PGA Tour makes sustained excellence almost impossible. And yet, Scottie Scheffler is making the extraordinary look routine.</p>`,
    category: "golf",
    author: AUTHORS[4],
    date: "2025-07-04",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 9,
    title: "UFC 310 Preview: The Fights That Could Reshape the Pound-for-Pound Rankings",
    excerpt: "A stacked UFC card promises fireworks this weekend. From title fights to rising contenders, here's everything you need to know.",
    content: `<p>UFC 310 might just be the most anticipated card of the year. With two title fights headlining and a murderers' row of talent on the undercard, Saturday night promises to be spectacular.</p>`,
    category: "mma",
    author: AUTHORS[1],
    date: "2025-07-04",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1680022546558-550eaf22351e?w=1200&h=600&fit=crop",
    featured: false,
    trending: true,
  },
  {
    id: 10,
    title: "World Athletics Championships: The Stars Set to Light Up Tokyo",
    excerpt: "The World Championships promise drama, records, and unforgettable moments. We preview the athletes and events to watch.",
    content: `<p>Tokyo will once again play host to the world's greatest athletes when the World Athletics Championships arrive this summer.</p>`,
    category: "athletics",
    author: AUTHORS[7],
    date: "2025-07-03",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1502904550040-7534597429ae?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 11,
    title: "Liverpool's Transfer Window Masterclass: Slot Building His Own Dynasty",
    excerpt: "Arne Slot has transformed Liverpool's approach to recruitment. The Dutchman's signings have been surgical, purposeful, and devastatingly effective.",
    content: `<p>When Arne Slot replaced Jürgen Klopp, skepticism was inevitable. How do you follow a legend? The answer, it turns out, is with quiet efficiency and a clear footballing philosophy.</p>`,
    category: "football",
    author: AUTHORS[0],
    date: "2025-07-03",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 12,
    title: "The Rise of Women's Boxing: Why the Sport Has Never Been More Exciting",
    excerpt: "From Katie Taylor to Claressa Shields, women's boxing is experiencing a golden age. Sell-out crowds and historic pay-per-view numbers tell the story.",
    content: `<p>Women's boxing has undergone a transformation that few could have predicted even a decade ago. What was once an afterthought has become must-see entertainment.</p>`,
    category: "boxing",
    author: AUTHORS[1],
    date: "2025-07-02",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1546711076-85a7923432ab?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 13,
    title: "McLaren's Resurgence: Norris and the Quest for a First World Title",
    excerpt: "Lando Norris has taken McLaren back to the front of the grid. With car development accelerating, can the Woking team finally deliver?",
    content: `<p>There's a reason the Tifosi-like devotion of McLaren fans has never wavered through the lean years. This team has history in its DNA, and Lando Norris is writing the latest chapter.</p>`,
    category: "f1",
    author: AUTHORS[2],
    date: "2025-07-01",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1699138346782-8a8b211c3da2?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
  {
    id: 14,
    title: "Wembanyama Effect: How One Player Is Transforming the San Antonio Spurs",
    excerpt: "Victor Wembanyama isn't just a generational talent — he's a franchise transformer. The young Frenchman is redefining what's possible for a player his size.",
    content: `<p>There are players who change teams, and then there are players who change the sport itself. Victor Wembanyama belongs firmly in the latter category.</p>`,
    category: "nba",
    author: AUTHORS[3],
    date: "2025-07-01",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1629901925121-8a141c2a42f4?w=1200&h=600&fit=crop",
    featured: false,
    trending: true,
  },
  {
    id: 15,
    title: "Stadium Atmosphere Rankings: The Best Matchday Experiences in World Football",
    excerpt: "From the Yellow Wall to the Kop, we rank the stadiums that deliver the most electrifying atmosphere on matchday.",
    content: `<p>Football is nothing without its fans. The songs, the pyro, the wall of noise — it's what separates the beautiful game from every other sport on earth.</p>`,
    category: "football",
    author: AUTHORS[0],
    date: "2025-06-30",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=1200&h=600&fit=crop",
    featured: false,
    trending: false,
  },
];

export const getArticlesByCategory = (categoryId) => {
  return ARTICLES.filter((a) => a.category === categoryId);
};

export const getFeaturedArticle = () => {
  return ARTICLES.find((a) => a.featured);
};

export const getTrendingArticles = () => {
  return ARTICLES.filter((a) => a.trending);
};

export const getLatestArticles = (limit = 10) => {
  return ARTICLES.slice(0, limit);
};

export const getArticleById = (id) => {
  return ARTICLES.find((a) => a.id === parseInt(id));
};

export const getRelatedArticles = (articleId, limit = 3) => {
  const article = getArticleById(articleId);
  if (!article) return [];
  return ARTICLES.filter((a) => a.id !== article.id && a.category === article.category).slice(0, limit);
};
